var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"text-center":"","wrap":""}},_vm._l((_vm.items),function(item,index){
var _obj;
return _c('v-flex',_vm._b({key:("commercial" + index)},'v-flex',( _obj = {}, _obj[("xs" + (!_vm.isSimulation && _vm.isDesktop ? 4 : 12))] = true, _obj ),false),[_c('commercial',{attrs:{"data":item}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }